import React from 'react';
import {Responsive, WithPermission} from 'admin-on-rest';
import {resolveAccess} from './shared/authFunctions';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {fuseLocationIcon as LocationIcon} from './Location/location';
import {fuseProductIcon as ProductIcon} from './Product/product';
import {fuseLocationInventoryIcon as LocationInventoryIcon} from './Inventory/locationInventory';
import {fuseVipCardConfigIcon as LoyaltyIcon} from './Loyalty/vipCardConfig';
import {fusePosUserIcon as POSUserIcon} from './User/posUser';
import {fuseConfigurationIcon as ConfigurationIcon} from './Setting/configuration';
import {Card, CardHeader, CardText, CardActions} from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import FlatButton from 'material-ui/FlatButton';
import {dashStyles} from './shared/styles-dashboard';

const styles = {
    dash: {flex: {display: 'flex'}},
    dashContainer: {position: 'relative'},
    dashTitle: {width: 'calc(100% - 180px)', boxSizing: 'border-box'},
    dashLogo: {position: 'absolute', top: '50%', right: 12, width: 180, height: 93, transform: 'translateY(-50%'},
    logoImage: {width: '100%', height: 'auto'},
};

export default () => (
    <div>
        <Responsive
            small={
                <Card style={{...styles.dash, ...dashStyles.marginBottom}}>
                    <ViewTitle title="Dashboard" style={styles.dashTitle}/>
                    <CardText style={styles.dashTitle}>
                        Welcome to the CloudSent POS Administration dashboard.
                    </CardText>
                </Card>
            }
            medium={
                <Card style={{...styles.dash, ...styles.dashContainer, ...dashStyles.marginBottom}}>
                    <div style={styles.dashLogo}>
                        <img src="CloudSent-POS-logo-admin.png" style={styles.logoImage} alt="CloudSent POS"/>
                    </div>
                    <ViewTitle title="Dashboard" style={styles.dashTitle}/>
                    <CardText style={styles.dashTitle}>
                        Welcome to the CloudSent POS Administration dashboard.
                    </CardText>
                </Card>
            }
        />

        {/* Locations */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['locations'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Physical Locations"
                    subtitle="Create and manage all of your Locations (Stores) for your Business. Manage DBAs,
                Companies, Location Types, Districts, Price Levels, and Additional Taxes."
                    avatar={<Avatar icon={<LocationIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to Locations" href="#/Location"/>
                </CardActions>
            </Card>
        </WithPermission>

        {/* Locations View Only */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['locations_vo'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Physical Locations"
                    subtitle="View all of your Locations (Stores) for your Business. View DBAs,
                Companies, Location Types, Districts, Price Levels, and Additional Taxes."
                    avatar={<Avatar icon={<LocationIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to Locations" href="#/Location"/>
                </CardActions>
            </Card>
        </WithPermission>

        {/* Products */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['products_all', 'products_np'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Products"
                    subtitle="Create and Manage all of your Products for your Business. Manage Product Types,
                Categories, Product Units, SKUs, and Discounts."
                    avatar={<Avatar icon={<ProductIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to Products" href="#/Product"/>
                </CardActions>
            </Card>
        </WithPermission>

        {/* Products View Only */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['products_vo'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Products"
                    subtitle="View all of your Products for your Business. View Product Types,
                Categories, Product Units, SKUs, and Discounts."
                    avatar={<Avatar icon={<ProductIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to Products" href="#/Product"/>
                </CardActions>
            </Card>
        </WithPermission>

        {/* Inventory */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['inventory'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Inventory"
                    subtitle="Manage your Inventory, Repacks, and Audits. Search for transferred Products and
                    Missing Products."
                    avatar={<Avatar icon={<LocationInventoryIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to Inventory" href="#/Inventory"/>
                </CardActions>
            </Card>
        </WithPermission>

        {/* Inventory View Only */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['inventory_vo'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Inventory"
                    subtitle="View your Inventory, Repacks, and Audits."
                    avatar={<Avatar icon={<LocationInventoryIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to Inventory" href="#/Inventory"/>
                </CardActions>
            </Card>
        </WithPermission>

        {/* Loyalty Program */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['loyalty_all'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Loyalty Program"
                    subtitle="Create and Manage Loyalty Program accounts, Ranks, Incentive Tiers, and fraud lists."
                    avatar={<Avatar icon={<LoyaltyIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to Loyalty Program" href="#/Loyalty"/>
                </CardActions>
            </Card>
        </WithPermission>
        <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['loyalty_csr'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Loyalty Program"
                    subtitle="Create and Manage Loyalty Program accounts."
                    avatar={<Avatar icon={<LoyaltyIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to Loyalty Program" href="#/Loyalty"/>
                </CardActions>
            </Card>
        </WithPermission>
        <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['loyalty_vo'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Loyalty Program"
                    subtitle="View Loyalty Program accounts, Ranks, Incentive Tiers, and fraud lists."
                    avatar={<Avatar icon={<LoyaltyIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to Loyalty Program" href="#/Loyalty"/>
                </CardActions>
            </Card>
        </WithPermission>

        {/* POS Users */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['pos_users'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="POS Users"
                    subtitle="Create and Manage all Users of your POS System."
                    avatar={<Avatar icon={<POSUserIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to POS Users" href="#/POSUser"/>
                </CardActions>
            </Card>
        </WithPermission>

        {/* POS Users View Only */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['pos_users_vo'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="POS Users"
                    subtitle="View all Users of your POS System."
                    avatar={<Avatar icon={<POSUserIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to POS Users" href="#/POSUser"/>
                </CardActions>
            </Card>
        </WithPermission>

        {/* POS Kits */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['pos_kit'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="POS Kits"
                    subtitle="Create and Manage all Kits of your POS System."
                    avatar={<Avatar icon={<POSUserIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to POS Kits" href="#/POSKit"/>
                </CardActions>
            </Card>
        </WithPermission>

        {/* POS Kits View Only */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['pos_kit_vo'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="POS Kits"
                    subtitle="View all Kits of your POS System."
                    avatar={<Avatar icon={<POSUserIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to POS Kits" href="#/POSKit"/>
                </CardActions>
            </Card>
        </WithPermission>

        {/* Configuration */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['configuration'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Configuration"
                    subtitle="Manage Configuration variables and Admin Test Mode."
                    avatar={<Avatar icon={<ConfigurationIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to Configuration" href="#/Configuration"/>
                </CardActions>
            </Card>
        </WithPermission>

        {/* Configuration View Only*/}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['configuration_vo'])}>
            <Card className="listCard"
                  style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Configuration"
                    subtitle="View Configuration variables."
                    avatar={<Avatar icon={<ConfigurationIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton label="Go to Configuration" href="#/Configuration"/>
                </CardActions>
            </Card>
        </WithPermission>
    </div>
);



// WEBPACK FOOTER //
// ./src/Fuse/dashboard.js